/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsService } from "../../entities/models/Service";
import { z } from "zod/v4";

export const modelsServiceSchema = z.object({
    "created_at": z.optional(z.string()),
"duration_minutes": z.optional(z.int()),
"id": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"name": z.optional(z.string()),
"price": z.optional(z.number()),
"service_type": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsService>